module.exports = __webpack_public_path__ + "img/cam-overlay-side.e21c9866.svg";